import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
// Main components
import MainLayout from "../../../components/main/layout/layout";
// Maintenance components
import MaintenanceView from "../../../components/maintenance/view/view";
// Actions
import * as mainActions from "../../../redux/actions/main";
import * as podcastsActions from "../../../redux/actions/podcasts";
// Styles
import "./view.css";

const PodcastsView = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [refreshData, setRefreshData] = useState(false);
  // Selectors
  const currentPage = useSelector((state) => state.mainReducer.currentPage);
  const user = useSelector(state => state.authReducer.user);

  // Set consts and vars
  const page = "podcasts";
  const itemNameSingular = "Podcast";

  useEffect(() => {
    if (!!currentPage) return;
    // Set active page
    dispatch(mainActions.setCurrentPage(page));
  }, []);

  // Set grid config
  const filters = [
    `podcasts_group_title`,
    `title`,
    `date`,
    `priority`,
    `text_audio`,
    `url_web`,
    `enabled`,
  ];
  const sorters = filters;
  const columns = [
    { 
      name: "files_2",
      width: `100px`,
      header: {
        dataType: "image",
        placeholder: "Imatge",
        textAlign: "center",
        disabled: true,
      },
      style: {
        textAlign: "center",       // Alinea el texto a la izquierda
        overflow: "hidden",      // Oculta cualquier desbordamiento fuera de la celda
      }
    },
    { 
      name: "podcasts_group_title",
      width: `250px`,
      header: {
        dataType: "string",
        placeholder: "Grup",
        textAlign: "left",
      },
      style: {
        textAlign: "left",
        overflow: "hidden",
        textOverflow: "ellipsis",
      }
    },  
    { 
      name: "title",
      header: {
        dataType: "string",
        placeholder: "Títol",
        textAlign: "left",
      },
      style: {
        textAlign: "left",       // Alinea el texto a la izquierda
        overflow: "hidden",      // Oculta cualquier desbordamiento fuera de la celda
        textOverflow: "clip",    // Desactiva los tres puntos (opcional)
        whiteSpace: "normal",    // Permite que el texto se ajuste en varias líneas
        wordBreak: "break-word", // Asegura que las palabras largas se corten si es necesario
      }
    },
    { 
      name: "date",
      width: `150px`,
      header: {
        dataType: "date",
        placeholder: "Data",
        textAlign: "center",
      },
      style: {
        textAlign: "center",
        overflow: "hidden",         // Oculta el contenido que sobresale
        textOverflow: "ellipsis",   // Muestra "..." si el texto es demasiado largo
        whiteSpace: "nowrap",       // Impide que el texto se divida en varias líneas
      }
    },
    { 
      name: "priority",
      width: `120px`,
      header: {
        dataType: "integer",
        placeholder: "Prioritat",
        textAlign: "center",
      },
      style: {
        textAlign: "center",
        overflow: "hidden",         // Oculta el contenido que sobresale
        textOverflow: "ellipsis",   // Muestra "..." si el texto es demasiado largo
        whiteSpace: "nowrap",       // Impide que el texto se divida en varias líneas
      }
    },
    { 
      name: "text_audio",
      width: `200px`,
      header: {
        dataType: "string",
        placeholder: "Títol àudio",
        textAlign: "left",
      },
      style: {
        textAlign: "left",       // Alinea el texto a la izquierda
        overflow: "hidden",      // Oculta cualquier desbordamiento fuera de la celda
        textOverflow: "clip",    // Desactiva los tres puntos (opcional)
        whiteSpace: "normal",    // Permite que el texto se ajuste en varias líneas
        wordBreak: "break-word", // Asegura que las palabras largas se corten si es necesario
      }
    },
    { 
      name: "url_web",
      width: `200px`,
      header: {
        dataType: "url",
        placeholder: "URL web",
        textAlign: "left",
      },
      style: {
        textAlign: "left",       // Alinea el texto a la izquierda
        overflow: "hidden",      // Oculta cualquier desbordamiento fuera de la celda
        textOverflow: "clip",    // Desactiva los tres puntos (opcional)
        whiteSpace: "normal",    // Permite que el texto se ajuste en varias líneas
        wordBreak: "break-word", // Asegura que las palabras largas se corten si es necesario
      }
    },
    { 
      name: "enabled",
      width: `105px`,
      header: {
        dataType: "boolean",
        placeholder: "Habilitat",
        textAlign: "center",
      },
      style: {
        textAlign: "center",
        overflow: "hidden",         // Oculta el contenido que sobresale
        textOverflow: "ellipsis",   // Muestra "..." si el texto es demasiado largo
        whiteSpace: "nowrap",       // Impide que el texto se divida en varias líneas
      }
    },
  ];

  return (
    <MainLayout isLoading={isLoading} setIsLoading={setIsLoading}>
      <div id="podcasts-view-content">
        <MaintenanceView 
          primaryKey={"id"}
          primaryNameKey={"title"}
          menuConfig={{
            buttonNew: { visible: !!user && user.grants.podcasts },
            buttonEdit: { visible: !!user && user.grants.podcasts },
            buttonDelete: { visible: !!user && user.grants.podcasts },
          }}
          gridConfig={{ 
            filters, 
            sorters, 
            columns,
            title: "Llista de <b>PODCASTS</b>",
            enablePagination: true,
            forceRefreshDataAtBegining: true,
          }}
          reducerName="podcastsReducer"
          itemNameSingular={itemNameSingular}
          itemIsMale={true}
          actions={podcastsActions} 
          setIsLoading={setIsLoading}
          setRefreshData={setRefreshData}
          refreshData={refreshData}
          isMultiRowSelection={true}
          page={"podcasts"}
        />
      </div>
    </MainLayout>
  );
};

export default PodcastsView;
